/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AltinnResponse
 */
export interface AltinnResponse {
    /**
     * 
     * @type {string}
     * @memberof AltinnResponse
     */
    firstname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AltinnResponse
     */
    surname?: string | null;
    /**
     * 
     * @type {string}
     * @memberof AltinnResponse
     */
    displayName?: string | null;
}

/**
 * Check if a given object implements the AltinnResponse interface.
 */
export function instanceOfAltinnResponse(value: object): value is AltinnResponse {
    return true;
}

export function AltinnResponseFromJSON(json: any): AltinnResponse {
    return AltinnResponseFromJSONTyped(json, false);
}

export function AltinnResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AltinnResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'firstname': json['firstname'] === undefined ? undefined : json['firstname'] === null ? null : json['firstname'],
        'surname': json['surname'] === undefined ? undefined : json['surname'] === null ? null : json['surname'],
        'displayName': json['displayName'] === undefined ? undefined : json['displayName'] === null ? null : json['displayName'],
    };
}

export function AltinnResponseToJSON(json: any): AltinnResponse {
    return AltinnResponseToJSONTyped(json, false);
}

export function AltinnResponseToJSONTyped(value?: AltinnResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'firstname': value['firstname'],
        'surname': value['surname'],
        'displayName': value['displayName'],
    };
}

